import { Box, Typography, Avatar, Chip, Grid, Paper, useTheme } from '@mui/material';
import PetsIcon from '@mui/icons-material/Pets';
import { PET_TYPE_TRANSLATIONS } from '../../constants/petConstants';

interface PetInfoProps {
  pet: any;
}

export function PetInfo({ pet }: PetInfoProps) {
  const theme = useTheme();

  return (
    <Box>
      {/* Header com foto e informações principais */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, mb: 4 }}>
        <Avatar 
          src={pet.foto} 
          sx={{ width: 120, height: 120, bgcolor: '#E0E7EF' }}
        >
          <PetsIcon sx={{ fontSize: 60, color: '#9CA3AF' }} />
        </Avatar>
        <Box>
          <Typography variant="h4" fontWeight={600} color={theme.palette.text.primary} mb={1}>
            {pet.nome}
          </Typography>
          <Typography variant="h6" color={theme.palette.text.secondary} mb={2}>
            {pet.raca} • {PET_TYPE_TRANSLATIONS[pet.tipo]}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Chip 
              label={`${pet.idade} anos`} 
              color="primary" 
              variant="outlined"
            />
            <Chip 
              label={`${pet.peso} kg`} 
              color="secondary" 
              variant="outlined"
            />
          </Box>
        </Box>
      </Box>

      {/* Grid de informações detalhadas */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '100%' }}>
            <Typography variant="h6" fontWeight={600} mb={2} color={theme.palette.text.primary}>
              Informações Básicas
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box>
                <Typography variant="body2" color={theme.palette.text.secondary}>
                  Nome
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                  {pet.nome}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" color={theme.palette.text.secondary}>
                  Tipo
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                  {PET_TYPE_TRANSLATIONS[pet.tipo]}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" color={theme.palette.text.secondary}>
                  Raça
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                  {pet.raca}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" color={theme.palette.text.secondary}>
                  Cor
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                  {pet.cor}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '100%' }}>
            <Typography variant="h6" fontWeight={600} mb={2} color={theme.palette.text.primary}>
              Características Físicas
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box>
                <Typography variant="body2" color={theme.palette.text.secondary}>
                  Idade
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                  {pet.idade} anos
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" color={theme.palette.text.secondary}>
                  Peso
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                  {pet.peso} kg
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>

        {pet.observacoes && (
          <Grid item xs={12}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" fontWeight={600} mb={2} color={theme.palette.text.primary}>
                Observações
              </Typography>
              <Typography variant="body1" color={theme.palette.text.primary}>
                {pet.observacoes}
              </Typography>
            </Paper>
          </Grid>
        )}
      </Grid>
    </Box>
  );
} 